angular.module('llax')
    .controller('MessagingController',
        function($rootScope, $scope, $http, $log, $translate, $timeout, ChannelService, CountMessageResource, HttpHeader, MessagingResource, QueryMessageResource, uiGridConstants) {

            $scope.messagingStatus = ['DEFERRED', 'PENDING', 'BLOCKED', 'SENDING', 'DELIVERED', 'SUCCESS', 'EXCEPTION', 'WARNING', 'FATAL',
                                      'RECEIVED', 'IMPORTING', 'IMPORTED', 'PENDING_PROCESSING', 'PROCESSING', 'PROCESSED' ,'ERROR', 'ABORTED'];

            $scope.hasCreatedAtDateFilter = function(channelId) {
                var params = $scope.additionalQueryParams[channelId];
                return params && (params.createdBefore || params.createdAfter);
            };

            $scope.hasChangedAtDateFilter = function(channelId) {
                var params = $scope.additionalQueryParams[channelId];
                return params && (params.changedBefore || params.changedAfter);
            };

            $scope.isMessagingDateFilterDisabled = function(field, channelId) {
                if (field === 'createdAt') {
                    return $scope.hasChangedAtDateFilter(channelId);
                }

                return $scope.hasCreatedAtDateFilter(channelId);
            };

            $scope.buildMessagingDateHeaderCellTemplate = function(channelId, field) {
                var otherFilterKey = field === 'createdAt' ?
                    'MESSAGING.CHANGED_AT' : 'MESSAGING.CREATED_AT';
                var disabledExpr = 'grid.appScope.isMessagingDateFilterDisabled(\'' + field + '\', ' + channelId + ')';
                var disabledTooltip = $translate.instant('MESSAGING.DATE_FILTER_DISABLED', {
                    filterName: $translate.instant(otherFilterKey)
                }).replace(/"/g, '&quot;');

                return '<div role="columnheader" class="messaging-date-filter-columnheader" ' +
                        'ng-class="{ \'sortable\': sortable, \'ui-grid-header-cell-last-col\': isLastCol }" ' +
                        'ui-grid-one-bind-aria-labelledby-grid="col.uid + \'-header-text \' + col.uid + \'-sortdir-text\'" ' +
                        'aria-sort="{{col.sort.direction == asc ? \'ascending\' : ( col.sort.direction == desc ? \'descending\' : (!col.sort.direction ? \'none\' : \'other\'))}}" ' +
                        'tooltip-html-unsafe="' + disabledTooltip + '" tooltip-placement="top" tooltip-append-to-body="true" ' +
                        'tooltip-trigger="mouseenter" tooltip-enable="' + disabledExpr + '">' +
                    '<div role="button" tabindex="0" ng-keydown="handleKeyDown($event)" ' +
                        'class="ui-grid-cell-contents ui-grid-header-cell-primary-focus messaging-date-filter-header" col-index="renderIndex">' +
                        '<span class="ui-grid-header-cell-label" ' +
                            'ng-class="{ \'column-header-label--disabled\': ' + disabledExpr + ' }" ' +
                            'ui-grid-one-bind-id-grid="col.uid + \'-header-text\'">' +
                            '{{ col.displayName CUSTOM_FILTERS }}' +
                        '</span>' +
                        '<span ui-grid-one-bind-id-grid="col.uid + \'-sortdir-text\'" ui-grid-visible="col.sort.direction" ' +
                            'aria-label="{{getSortDirectionAriaLabel()}}">' +
                            '<i ng-class="{ \'ui-grid-icon-up-dir\': col.sort.direction == asc, ' +
                                '\'ui-grid-icon-down-dir\': col.sort.direction == desc, ' +
                                '\'ui-grid-icon-blank\': !col.sort.direction }" ' +
                                'title="{{isSortPriorityVisible() ? i18n.headerCell.priority + \' \' + ( col.sort.priority + 1 ) : null}}" ' +
                                'aria-hidden="true"></i>' +
                            '<sub ui-grid-visible="isSortPriorityVisible()" class="ui-grid-sort-priority-number">{{col.sort.priority + 1}}</sub>' +
                        '</span>' +
                    '</div>' +
                    '<div role="button" tabindex="0" ui-grid-one-bind-id-grid="col.uid + \'-menu-button\'" ' +
                        'class="ui-grid-column-menu-button" ' +
                        'ng-if="grid.options.enableColumnMenus && !col.isRowHeader && col.colDef.enableColumnMenu !== false" ' +
                        'ng-click="toggleMenu($event)" ng-keydown="headerCellArrowKeyDown($event)" ' +
                        'ui-grid-one-bind-aria-label="i18n.headerCell.aria.columnMenuButtonLabel" ' +
                        'aria-expanded="{{col.menuShown}}" aria-haspopup="true">' +
                        '<i class="ui-grid-icon-angle-down" aria-hidden="true">&nbsp;</i>' +
                    '</div>' +
                    '<div ui-grid-filter ng-hide="col.filterContainer === \'columnMenu\'"></div>' +
                '</div>';
            };

            $scope.buildMessagingDateFilterHeaderTemplate = function(channelId, field) {
                var afterKey = field === 'createdAt' ? 'createdAfter' : 'changedAfter';
                var beforeKey = field === 'createdAt' ? 'createdBefore' : 'changedBefore';
                var afterInputName = field + '-after-' + channelId;
                var beforeInputName = field + '-before-' + channelId;

                return '<div class="ui-grid-filter-container" style="padding-left: 2px;padding-right: 15px;">' +
                    '<div style="margin-bottom:3px">' +
                        '<span class="syncons syncons-double-arrows-right"></span>' +
                        '<input type="text" name="' + afterInputName + '" style="width: 88%;height: 20px;"' +
                        'data-ng-model="grid.appScope.additionalQueryParams[' + channelId + '].' + afterKey + '" ' +
                        'data-ng-disabled="grid.appScope.isMessagingDateFilterDisabled(\'' + field + '\', ' + channelId + ')" ' +
                        'data-ng-change="grid.appScope.onMessagingDateFilterChange(' + channelId + ', \'' + field + '\', \'after\')"' +
                        'data-lax-datetime-picker data-lax-datepicker-grid/>' +
                        '<span data-ng-show="grid.appScope.additionalQueryParams[' + channelId + '].' + afterKey + '" ' +
                            'data-ng-click="grid.appScope.clearMessagingDateFilterBound(' + channelId + ', \'' + field + '\', \'after\')"' +
                            'style="position: absolute;marging-left: -2px;">' +
                            '<i class="ui-grid-icon-cancel" ui-grid-one-bind-aria-label="aria.removeFilter" aria-label="Remove Filter">&nbsp;</i></span>' +
                    '</div>' +
                    '<div>' +
                        '<span class="syncons syncons-double-arrows-left"></span>' +
                        '<input type="text" name="' + beforeInputName + '" style="width: 88%;height: 20px;"' +
                        'data-ng-model="grid.appScope.additionalQueryParams[' + channelId + '].' + beforeKey + '" ' +
                        'min-date="grid.appScope.additionalQueryParams[' + channelId + '].' + afterKey + '" ' +
                        'data-ng-disabled="grid.appScope.isMessagingDateFilterDisabled(\'' + field + '\', ' + channelId + ')" ' +
                        'data-ng-change="grid.appScope.onMessagingDateFilterChange(' + channelId + ', \'' + field + '\', \'before\')"' +
                        'data-lax-datetime-picker data-lax-datepicker-grid/>' +
                        '<span data-ng-show="grid.appScope.additionalQueryParams[' + channelId + '].' + beforeKey + '" ' +
                            'data-ng-click="grid.appScope.clearMessagingDateFilterBound(' + channelId + ', \'' + field + '\', \'before\')"' +
                            'style="position: absolute;marging-left: -2px;">' +
                            '<i class="ui-grid-icon-cancel" ui-grid-one-bind-aria-label="aria.removeFilter" aria-label="Remove Filter">&nbsp;</i></span>' +
                    '</div>' +
                '</div>';
            };

            $scope.createColumnDefs = function(channelId) {
                return [{
                    field: 'direction',
                    displayName: $translate.instant('MESSAGING.DIRECTION'),
                    width: '*',
                    headerCellClass: 'text-center',
                    filter: {
                        type: uiGridConstants.filter.SELECT,
                        selectOptions: [ { value: 'INBOUND', label: 'INBOUND' }, { value: 'OUTBOUND', label: 'OUTBOUND' } ]
                    }
                }, {
                    field: 'createdAt',
                    displayName: $translate.instant('MESSAGING.CREATED_AT'),
                    cellFilter: "date:'medium'",
                    headerCellClass: 'text-center',
                    headerCellTemplate: $scope.buildMessagingDateHeaderCellTemplate(channelId, 'createdAt'),
                    filterHeaderTemplate: $scope.buildMessagingDateFilterHeaderTemplate(channelId, 'createdAt'),
                    width: '*'
                }, {
                    field: 'changedAt',
                    displayName: $translate.instant('MESSAGING.CHANGED_AT'),
                    cellTooltip: true,
                    cellFilter: "date:'medium'",
                    headerCellClass: 'text-center',
                    headerCellTemplate: $scope.buildMessagingDateHeaderCellTemplate(channelId, 'changedAt'),
                    filterHeaderTemplate: $scope.buildMessagingDateFilterHeaderTemplate(channelId, 'changedAt'),
                    width: '*',
                }, {
                    field: 'contentType',
                    displayName: $translate.instant('MESSAGING.CONTENT_TYPE'),
                    headerTooltip: true,
                    cellTooltip: true,
                    width: '*',
                    headerCellClass: 'text-center',
                    enableFiltering: false
                }, {
                    field: 'path',
                    displayName: $translate.instant('MESSAGING.PATH'),
                    headerTooltip: true,
                    cellTooltip: true,
                    width: '*',
                    headerCellClass: 'text-center',
                    enableFiltering: false
                }, {
                    field: 'status',
                    displayName: $translate.instant('STATUS'),
                    headerTooltip: true,
                    width: '*',
                    headerCellClass: 'text-center',
                    filter: {
                        type: uiGridConstants.filter.SELECT,
                        selectOptions: _.map($scope.messagingStatus, function(val) {
                            return { value: val, label: val };
                        })
                    },
                    cellTemplate: '<div class="ui-grid-cell-contents text-center">' +
                                '<span class="label" data-ng-class="grid.appScope.getStatusLabel(row.entity.finalStatus || row.entity.status)">{{grid.appScope.formatMessagingStatusDisplay(row.entity)}}</span>' +
                            '</div>'
                }, {
                    field: 'actions',
                    displayName: $translate.instant('ACTIONS'),
                    headerTooltip: true,
                    width: '*',
                    headerCellClass: 'text-center',
                    cellClass: 'text-right',
                    enableColumnMenu: false,
                    enableColumnResizing: false,
                    enableFiltering: false,
                    enableHiding: false,
                    enableSorting: false,
                    pinnedRight: true,
                    resizable: false,
                    cellTemplate: '' +
                        '<div class="btn-group">\n' +
                        '    <a class="btn btn-xs btn-cell"\n' +
                        '      title="{{\'MESSAGING.IMPORTED_ITEMS\' | translate}}"\n' +
                        '      data-ng-show="row.entity.status == \'IMPORTED\'"\n' +
                        '      data-ng-href="/browse?tags=inboundMessage:{{row.entity.assetKey}}"\n' +
                        '      target="_self">\n' +
                        '        <span class="syncons syncons-search"></span>\n' +
                        '    </a>\n' +
                        '    <btn class="btn btn-xs btn-cell"\n' +
                        '      title="{{\'MESSAGING.DETAILS\' | translate}}"\n' +
                        '      data-ng-click="grid.appScope.showMessagingDetails(row.entity)">\n' +
                        '        <span class="syncons syncons-item-detail"></span>\n' +
                        '    </btn>\n' +
                        '    <a class="btn btn-xs btn-cell"\n' +
                        '      title="{{\'MESSAGING.DOWNLOAD_MESSAGE\' | translate}}"\n' +
                        '      data-ng-href="{{grid.appScope.downloadMessage(row.entity.id)}}"\n' +
                        '      target="_self">\n' +
                        '        <span class="syncons syncons-download"></span>\n' +
                        '    </a>\n' +
                        '</div>'
                }];
            };

            $scope.createChannelMessagesGridOptions = function (channelId) {
                return {
                    data: 'channels['+channelId+'].messages',
                    enableColumnMenus: false,
                    enableColumnMoving : true,
                    enableColumnResize: true,
                    enableFiltering: true,
                    enableGridMenu: true,
                    enableRowSelection: false,
                    infiniteScrollDown: true,
                    useExternalFiltering: true,
                    rowHeight: 34,
                    columnDefs: $scope.createColumnDefs(channelId),
                    onRegisterApi: function(gridApi) {
                        $scope.gridApi = gridApi;
                        gridApi.infiniteScroll.on.needLoadMoreData($scope, function(){
                            $scope.loadMoreMessages(channelId);
                        });
                        $timeout(function() {
                            $scope.gridApi.core.handleWindowResize();
                        });
                        gridApi.core.on.filterChanged($scope, function() {
                                var grid = this.grid;
                                var channel = grid.appScope.channels[channelId];
                                if (channel) {
                                    var params = $scope.additionalQueryParams[channel.id];
                                    var filterColumns = _.filter(grid.columns, function(col) {
                                        return !_.isEmpty(col.filter);
                                    });
                                    _.forEach(filterColumns, function(fCol) {
                                        if (fCol.filter.term) {
                                            params[fCol.field] = fCol.filter.term;
                                        } else {
                                            delete params[fCol.field];
                                        }
                                    });
                                    $scope.reloadMessages(channel, true);
                                }
                            }
                        );
                    }
                };
            };

            $scope.channelMessagesGridOptionsMap = {};
            $scope.getChannelMessagesGridOptions = function(id) {
                $scope.channelMessagesGridOptionsMap[id] = angular.copy($scope.createChannelMessagesGridOptions(id));
            };

            $scope.clearMessagingDateFilterBound = function(channelId, field, bound) {
                var params = $scope.additionalQueryParams[channelId];
                if (!params) {
                    return;
                }

                if (field === 'createdAt') {
                    delete params[bound === 'after' ? 'createdAfter' : 'createdBefore'];
                } else {
                    delete params[bound === 'after' ? 'changedAfter' : 'changedBefore'];
                }

                var channel = $scope.channels[channelId];
                if (channel) {
                    $scope.reloadMessages(channel, true);
                }
            };

            $scope.onMessagingDateFilterChange = function(channelId, field, bound) {
                var params = $scope.additionalQueryParams[channelId];
                if (!params) {
                    params = $scope.additionalQueryParams[channelId] = {};
                }

                if (field === 'createdAt') {
                    delete params.changedBefore;
                    delete params.changedAfter;
                    if (bound === 'after') {
                        delete params.createdBefore;
                    }
                } else {
                    delete params.createdBefore;
                    delete params.createdAfter;
                    if (bound === 'after') {
                        delete params.changedBefore;
                    }
                }

                _.forEach(['createdBefore', 'createdAfter', 'changedBefore', 'changedAfter'], function(key) {
                    if (params[key] && !angular.isDate(params[key])) {
                        delete params[key];
                    }
                });

                var channel = $scope.channels[channelId];
                if (channel) {
                    $scope.reloadMessages(channel, true);
                }
            };

            $scope.translateStatus = function(status) {
                status = $rootScope.translateValue('MESSAGING.STATUS.', status);
                return status;
            };

            $scope.formatMessagingStatusDisplay = function(message) {
                var currentStatus = $scope.translateStatus(message.status);
                if (message.finalStatus) {
                    return currentStatus + ' \u2192 ' + $scope.translateStatus(message.finalStatus);
                }
                return currentStatus;
            };

            $scope.gridOptionsMap = {};

            ChannelService.register(ChannelService.MESSAGING_ASSET_CHANGED_EVENT);

            $scope.$on('$destroy', function() {
                ChannelService.unregister(ChannelService.MESSAGING_ASSET_CHANGED_EVENT);
            });

            $scope.$on('channelMessageReceived', function(event, eventData) {
                if (eventData.event === ChannelService.MESSAGING_ASSET_CHANGED_EVENT) {
                    $log.debug("Messaging Asset Changed", eventData.data.typeOfChange, eventData.data.messagingAsset);

                    var messagingAsset = eventData.data.messagingAsset;
                    var channelId = messagingAsset.channelId;
                    var channel = $scope.channels[channelId];
                    if (!channel) {
                        $log.debug("Unknown channel:", channelId);
                        return;
                    }
                    if (!channel.showDetails.messages) {
                        $log.debug("Messages not shown for channel:", channelId);
                        return;
                    }
                    if (eventData.data.typeOfChange == 'uploaded') {
                        // FIXME: Add uploaded message
                        $scope.reloadMessages(channel, false);
                    } else {
                        // FIXME: Find message and update it
                        $scope.reloadMessages(channel, false);
                    }

                }
            });

            function scopeVarForCreatorData(creatorId, creatorType) {
                return 'messages_' + creatorId + '_' + creatorType;
            }

            $scope.getGridOptions = function(creatorId, creatorType) {
                var scopeVariable = scopeVarForCreatorData(creatorId, creatorType);
                $scope[scopeVariable] = [];

                var gridOptions = {
                    data: $scope[scopeVariable],
                    // FIXME: Actually create the columnDefs instead using the "default" which tries to determine them by the data!
                    // columnDefs: $scope.columnDefs,
                    enableColumnMenus: false,
                    enableColumnMoving : true,
                    enableColumnResize: true,
                    enableGridMenu: true,
                    enableRowSelection: false,
                    rowHeight: 34
                };
                $scope.gridOptionsMap[creatorId] = gridOptions;
            };

            $scope.loadMessagesForCreator = function(creatorId, creatorType, channel) {
                var scopeVariable = scopeVarForCreatorData(creatorId, creatorType);
                MessagingResource.query({
                        creatorId: creatorId,
                        creatorType: creatorType,
                        channelId: channel.id
                    }, {},
                    function(messagingAssets) {
                        // FIXME: As long as we do not have proper grid columns, we want to at least see dates as actual dates!
                        _.forEach(messagingAssets, function(messagingAsset) {
                            messagingAsset.createdAt = new Date(messagingAsset.createdAt).toISOString();
                            messagingAsset.changedAt = new Date(messagingAsset.changedAt).toISOString();
                        });
                        angular.extend($scope[scopeVariable], messagingAssets);
                    },
                    function(response) {
                        $scope.status = response.status;
                    });
            };

            $scope.countMessages = function(channel) {
                var queryParams = {
                    channelId: channel.id,
                };

                if (!_.isEmpty($scope.additionalQueryParams[channel.id])) {
                    angular.extend(queryParams, $scope.additionalQueryParams[channel.id]);
                }

                if (!channel.countingInProgress) {
                    channel.countingInProgress = true;
                    channel.countErrorMessage = null;

                    CountMessageResource.get(queryParams, {},
                        function (response) {
                            channel.countMessage = $rootScope.translate("MESSAGING.COUNT", "Number of messages: {{response.numberOfMessages}}", {'messageCount':response.numberOfMessages});
                            channel.countErrorMessage = null;
                            channel.needsCount = false;
                            channel.countingInProgress = false;
                        },
                        function (response) {
                            channel.countErrorMessage = $rootScope.getErrorMessage(response);
                            channel.needsCount = false;
                            channel.countingInProgress = false;
                        }
                    );
                }
            };

            function fetchCallback(channel, doCount, alsoInAccurateValue) {
                var cnt = channel.messages.length;

                if (channel.cursor == null) {
                    channel.countMessage = $rootScope.translate("MESSAGING.COUNT", "Number of messages: {{response.numberOfMessages}}", {'messageCount':cnt});
                    channel.needsCount = false;
                } else {
                    if (alsoInAccurateValue) {
                        channel.countMessage = $rootScope.translate("MESSAGING.COUNT_GREATER", "Number of messages: >= {{response.numberOfMessages}}", {'messageCount':cnt});
                    }
                    channel.needsCount = true;
                }

                channel.countErrorMessage = null;

                if (doCount && channel.needsCount) {
                    $scope.countMessages(channel);
                }
            }

            $scope.reloadMessages = function(channel, doCount) {
                if (!channel.loadingMessages) {
                    channel.cursor = null;
                    channel.loadingMessages = true;
                    config = {append:false};
                    $scope.fetchMessagesForChannel(channel, config, function() {
                        fetchCallback(channel, doCount, false);
                    });
                }
            };

            $scope.loadMoreMessages = function(channelId, config, channel) {
                channel = channel || $scope.gridApi.grid.appScope.channels[channelId];
                if (!channel.loadingMessages && !channel.searchComplete) {
                    channel.loadingMessages = true;
                    config = config || {append:true};
                    doCount = (channel.cursor == null);

                    $scope.fetchMessagesForChannel(channel, config, function() {
                        fetchCallback(channel, doCount, true);
                    });
                }
            };

            $scope.fetchMessagesForChannel = function(channel, config, callback) {
                var queryParams = {
                    channelId: channel.id,
                    limit: 20
                };

                if (!_.isEmpty($scope.additionalQueryParams[channel.id])) {
                    angular.extend(queryParams, $scope.additionalQueryParams[channel.id]);
                }

                QueryMessageResource.createCursorAwareResource(channel.cursor).query(queryParams,
                    function(messagingResponse, headers) {
                        var cursor = headers(HttpHeader.MESSAGE_CURSOR);

                        channel.cursor = cursor;

                        if (messagingResponse.length === 0) {
                            channel.searchComplete = true;
                        } else {
                            channel.searchComplete = false;
                        }
                        _.forEach(messagingResponse, function(message) {
                            message.translatedStatus = $rootScope.translateValue('MESSAGING.STATUS.', message.status);
                            if (message.finalStatus) {
                                message.translatedFinalStatus =
                                    $rootScope.translateValue('MESSAGING.STATUS.', message.finalStatus);
                            }
                            message.translatedCreatorType = $rootScope.translateValue('MESSAGING.CREATOR_TYPE.', message.creatorType);
                        });
                        if (config.append) {
                            channel.messages = channel.messages.concat(messagingResponse);
                        } else {
                            channel.messages = messagingResponse;
                        }
                        if ($scope.gridApi) {
                            $scope.gridApi.infiniteScroll.dataLoaded(false, true);
                        }
                        channel.loadingMessages = false;

                        if (callback) {
                            callback();
                        }
                    }, function(response) {
                        if ($scope.gridApi) {
                            $scope.gridApi.infiniteScroll.dataLoaded(false, true);
                        }
                        $scope.status = response.status;
                        channel.loadingMessages = false;
                    }
                );
            };

            $scope.downloadMessage = function(messagingAssetId) {
                return lax_rest_url('messaging/messagingassets/') + messagingAssetId + '?download=true';
            };

            $scope.additionalQueryParams = {};

            $scope.toggleShowMessages = function(channel) {
                channel.cursor = null;
                $scope.additionalQueryParams[channel.id] = {};
                channel.showDetails.messages = !channel.showDetails.messages;
                if (channel.showDetails.messages) {
                    $scope.loadMoreMessages(channel.id, { append: false }, channel);
                }
            };

        }
    );
